export default __webpack_public_path__ + "static/media/Bonus.6b8331d2.webp";